import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'

import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

// export const appAllGetContribution = createAsyncThunk(
// 	'appContribution/appAllGetContribution',
// 	async params => {
// 		try {
// 			let url = `/contribution?page=${params.page}&limit=${params.limit}`
// 			if (params.hub) {
// 				url += `&hub=${params.hub}`
// 			}
// 			if (params.sanstha) {
// 				url += `&sansthaId=${params.sanstha}`
// 			}
// 			if (params.contributionType) {
// 				url += `&contributionType=${params.contributionType}`
// 			}
// 			if (params.startDate) {
// 				url += `&startDate=${params.startDate}`
// 			}
// 			if (params.endDate) {
// 				url += `&endDate=${params.endDate}`
// 			}
// 			const response = await httpService.get(url)
// 			return await response.data.data
// 		} catch (error) {
// 			toast.error(error?.message)
// 		}
// 	},
// )

export const appAllGetContribution = createAsyncThunk(
	'appContribution/appAllGetContribution',
	async (params = {}) => {
		try {
			const {
				page = 1,
				limit = 10,
				loading = true,
				hub,
				sanstha,
				contributionType,
				startDate,
				endDate,
			} = params

			let url = `/contribution?page=${page}&limit=${limit}`

			if (hub) url += `&hub=${hub}`
			if (sanstha) url += `&sansthaId=${sanstha}`
			if (contributionType) url += `&contributionType=${contributionType}`
			if (startDate) url += `&startDate=${startDate}`
			if (endDate) url += `&endDate=${endDate}`

			const response = await httpService.get(url, {}, {}, { loading })

			return response.data.data
		} catch (error) {
			toast.error(error?.message || 'Failed to fetch contributions')
			throw error
		}
	},
)

export const appUpdateContribution = createAsyncThunk(
	'appContribution/appUpdateContribution',
	async params => {
		try {
			const response = await httpService.put(
				`/contribution/${params.id}`,
				{},
				{
					status: params.status,
					rejectionreason: params.rejectionreason,
				},
			)

			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appDeleteContribution = createAsyncThunk(
	'appContribution/appDeleteContribution',
	async id => {
		try {
			const response = await httpService.delete(`/contribution/${id}`)
			if (response?.data) {
				response.data.id = id
				toast.success('Contribution Deleted Successfully')
			}
			return await response.data
		} catch (error) {
			toast.error(error?.message)
		}
	},
)

export const appContributionSlice = createSlice({
	name: 'Contribution',
	initialState: {
		contribution: [],
		isloder: false,
		paginate: '',
		isdeleted: false,
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appAllGetContribution.pending), (state, action) => {
			state.isloder = true
		})
		builder.addMatcher(isAllOf(appAllGetContribution.fulfilled), (state, action) => {
			state.contribution = action.payload
			const paginate = {
				hasNextPage:
					action?.payload?.pagination?.totalPages > action?.payload?.pagination?.currentPage,
				hasPrevPage: action?.payload?.pagination?.currentPage > 1,
				limit: action?.payload?.pagination?.pageSize,
				nextPage: action?.payload?.pagination?.currentPage + 1,
				page: action?.payload?.pagination?.currentPage,
				pagingCounter:
					(action?.payload?.pagination?.currentPage - 1) * action?.payload?.pagination?.pageSize +
					1,
				prevPage: action?.payload?.pagination?.currentPage - 1,
				totalDocs: action?.payload?.pagination?.totalRecords,
				totalPages: action?.payload?.pagination?.totalPages,
			}
			state.paginate = paginate
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appAllGetContribution.rejected), (state, action) => {
			state.isloder = false
		})
	},
})

export default appContributionSlice.reducer
